import { Array } from "@siteimprove/alfa-array";
import { Rule } from "../rule.js";
/**
 * @public
 */
export class GroupingRule extends Rule {
    _rules;
    constructor(type, rules) {
        super(type);
        this._rules = rules.filter((rule) => rule._attachParent(this));
    }
    get rules() {
        return this._rules;
    }
    *children() {
        yield* this._rules;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            rules: Array.toJSON(this._rules),
        };
    }
}
/**
 * @public
 */
(function (GroupingRule) {
    function isGroupingRule(value) {
        return value instanceof GroupingRule;
    }
    GroupingRule.isGroupingRule = isGroupingRule;
})(GroupingRule || (GroupingRule = {}));
//# sourceMappingURL=grouping.js.map